import { ApiService } from "src/app/services/api.service";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

export interface StockDetail {
  symbolCode: string;
  arbName: null | string;
  engName: null | string;
  reuters: string;
}

@Injectable({
  providedIn: "root",
})
export class  MarketWatchDetailService {
  marketNames: BehaviorSubject<StockDetail[]>;
  namesSubject: Subject<StockDetail[]> = new Subject<StockDetail[]>();

  constructor(private _service: ApiService) {
    this._service.fetchMarketWatchNames().subscribe((res: StockDetail[]) => {
      this.namesSubject.next(res);
      this.marketNames = new BehaviorSubject<StockDetail[]>(res);
    });
  }
}
